// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"23491623","140":"0cbbf4ce","167":"82416826","534":"4ba66d36","569":"d6dbfc9c","783":"89a0b872"}[chunkId] + ".chunk.js";
};